import React, { useState, useEffect, useRef } from 'react';
import { Card } from 'primereact/card';
import { getInstructivos } from './Services/instructivos.service';


const Instructivos = () => {
    const [videos, setVideos] = useState(null)

    useEffect(() => {
        (async () => {
            const {data,status} = await getInstructivos()
            setVideos(data)
        })();
    }, [])


    return (
         

            <div className="row">
                <div class="col-3"></div>
                <div className="col-6">
                    <div style={{ paddingTop: '1.5rem', paddingBottom: '1rem' }}>
                        <Card title="" style={{ width: '100%', backgroundColor: '#EEEEEE' }} >
                    <div className='justify-content-center  card-container align-content-center' style={{ textAlign: 'center' }}>
                        <h2 style={{ fontWeight: 'bold', fontSize: '2rem' }}>Instructivos</h2>
                        <p style={{ fontSize: '14px' }}>Acá vas a poder encontrar todos los instructivos necesarios para la Web</p>
                    </div>
                </Card>
                    </div>
                    <div className=' row' style={{ justifyContent: 'center' }}>
                {videos != null &&
                    videos.instructivos.map(video => (
                                <div className=' ' style={{ textAlign: 'center', fontWeight: 'bold', paddingTop: '1.5rem' }}>
                                    {video.descripcion}
                            <iframe src={video.direccionVideo} height={350} width={700} />
                        </div>

                    ))}
                    </div>
                </div>
                <div className="col-3"></div>

            </div>
        


    );
};

export default Instructivos;